import { Divider, Grid, Typography } from "@mui/material";
import { Dispatch, SetStateAction } from "react";
import { useParams } from "react-router-dom";
import { OrganizationUser } from "schemas/dashboard";
import { SetAlertType } from "schemas/functions";

import AdminAffiliateOrganization from "../Affiliate";
import AdminPersonalizedPlan from "../PersonalizedPlan";
import Settings from "../Settings";
import AdminAddOns from "../Settings/AddOns";
import AdminSearchThreads from "../Threads";
import AdminUserSearchPreferences from "../UserSearchPreferences";

interface AdminOrganizationViewProps {
  setAlert: SetAlertType;
  organizationUser: OrganizationUser | null;
  setOrganizationUser: Dispatch<SetStateAction<OrganizationUser | null>>;
  setOrgUsers: Dispatch<SetStateAction<OrganizationUser[]>>;
}

export default function AdminOrganizationView({
  setAlert,
  organizationUser,
  setOrganizationUser,
  setOrgUsers,
}: AdminOrganizationViewProps) {
  const { id } = useParams();

  return id ? (
    <Grid>
      <Typography variant="h4" sx={{ mt: 3 }}>
        {organizationUser
          ? `${organizationUser.name} - ${organizationUser.email}`
          : `Organization ${id}`}
      </Typography>
      <Settings
        organizationId={Number(id)}
        setAlert={setAlert}
        organizationUser={organizationUser}
        setOrganizationUser={setOrganizationUser}
        setOrgUsers={setOrgUsers}
      />

      <Divider sx={{ my: 3 }} />
      <AdminUserSearchPreferences
        organizationId={Number(id)}
        setAlert={setAlert}
      />

      <Divider sx={{ my: 3 }} />
      <AdminPersonalizedPlan organizationId={Number(id)} setAlert={setAlert} />

      <Divider sx={{ my: 3 }} />
      <AdminAddOns organizationUser={organizationUser} setAlert={setAlert} />
      <Divider sx={{ my: 3 }} />
      <AdminAffiliateOrganization
        organizationUser={organizationUser}
        setAlert={setAlert}
      />
      <Divider sx={{ my: 3 }} />
      <Typography variant="h4" sx={{ my: 2 }}>
        <strong>View Emails</strong>
      </Typography>
      <AdminSearchThreads organizationId={Number(id)} setAlert={setAlert} />
    </Grid>
  ) : (
    <></>
  );
}
